export default {
  data() {
    return {
      hasFormInfo: null
    };
  },
  methods: {
    /**
     * drawer关闭前和取消时的判断
     * @param { 是否有修改 } isState
     * @param { 关闭的回调 } done
     */
    beforeCloseMixin(isState, done) {
      if (isState) {
        this.$confirm(this.$t('pc_common_tip_confirmcancle').d('当前操作尚未保存，是否确认取消？'), '确认取消？', {
          confirmButtonText: this.$t('pc_biz_common_btn_sure').d('确定'),
          cancelButtonText: this.$t('pc_biz_core_btn_cancel').d('取消'),
          type: 'warning'
        }).then(() => {
          done();
        }).catch(() => {});
      } else {
        done();
      }
    },
    /**
     * 判断数据是否变化
     * @param { 初始数据 } form
     * @param { 操作的数据 } target
     * @returns Boolean
     */
    useFormChange(form) {
      const old = JSON.stringify(form);
      return target => {
        return old !== JSON.stringify(target);
      };
    }
  }
};
